// extracted by mini-css-extract-plugin
export var cdInstaFeedTags = "instafeed-module--cd-instaFeed-tags--dbfa5";
export var cdInstaFeedText = "instafeed-module--cd-instaFeed-text--08bc4";
export var instaFeed = "instafeed-module--instaFeed--10ceb";
export var instaFeedItem = "instafeed-module--instaFeed-item--360f4";
export var instaFeedItemWrapper = "instafeed-module--instaFeed-item-wrapper--3f5fb";
export var instaFeedSection = "instafeed-module--instaFeed-section--0bbe3";